import { render, staticRenderFns } from "./OfficeRoleForHref.vue?vue&type=template&id=357e56c9&scoped=true&"
import script from "./OfficeRoleForHref.vue?vue&type=script&lang=js&"
export * from "./OfficeRoleForHref.vue?vue&type=script&lang=js&"
import style0 from "./OfficeRoleForHref.vue?vue&type=style&index=0&id=357e56c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357e56c9",
  null
  
)

export default component.exports